import Alpine from "alpinejs";
import { centsToPrice } from "../../_utils/filters";

export const alpineDirectivePrice = () => {
  Alpine.directive("price", (el, { expression }, { evaluateLater, effect }) => {
    let getCents = evaluateLater(expression);

    effect(() => {
      getCents((cents) => {
        el.innerHTML = centsToPrice(cents);
      });
    });
  });
};
